module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAMFBMVEUAAAA6leg6lOg6lek5lek6l+hdov85lOc5lOg6l+g8lOg7lOdAleo6leg6lOg5lOdLomXoAAAAD3RSTlMA89uXjVMF1aVCNysM5r0JV31CAAAAtElEQVQY02NgYNhS+B8CxL0ZgCD5PwKYMTCwvf+8hgECTtn/S2Bg/juBAQY47xsw7P/JgADzfzP4GwDp1CZBjTAgzfyFoX4BAwOrPtCsTwEMDFzfGeQPMDD4gw3/wsDA85HhPwMDC9Q2BwYgD8iPh/K/Qvhs+lD+pwQwnxXuvAAwnwPObwDzmeB8BTCfEc4XQOejq0c3D90+dPdguhfdP+j+RQ8P9PBCD0/08EaPD/T4Qo9PAIrJ9wl99mypAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/family/checkbox.png
// module id = H/LA
// module chunks = 1